"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEntitiesContext = void 0;
const React = __importStar(require("react"));
const graphql_entity_state_1 = require("../graphql-entity-state");
const productEntitiesContext = React.createContext({
    type: "ProductEntitiesContext",
    entities: {},
    mergeEntities: () => {
        /*  */
    }
});
class ProductEntitiesContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "ProductEntitiesContext",
            mergeEntities: this.mergeEntities.bind(this),
            entities: {}
        };
    }
    mergeEntities(entities) {
        this.props.dispatch((0, graphql_entity_state_1.mergeProductEntities)(entities));
    }
    static getDerivedStateFromProps(props, state) {
        if (props.entities !== state.entities) {
            return {
                entities: props.entities
            };
        }
        return null;
    }
    render() {
        // Make sure there's only one child
        // https://reactjs.org/docs/react-api.html#reactchildrenonly
        return (React.createElement(productEntitiesContext.Provider, { value: this.state }, React.Children.only(this.props.children)));
    }
}
exports.ProductEntitiesContext = {
    Provider: ProductEntitiesContextProvider,
    Consumer: productEntitiesContext.Consumer
};
//# sourceMappingURL=product-entities-context.js.map